import T from '../types';

export default () => (bonusCurrency) => ({
  type: T.BONUS_CURRENCY_SET,
  bonusCurrency,
});
